// Where the "New messages" line goes — one rule for both apps' lists.

import type { CommsMessage } from '../../interfaces/ICommsApi.js';

/**
 * The first incoming message strictly newer than the read cursor captured
 * when the conversation was opened — the line goes above it. Undefined when
 * there is no cursor, nothing new, or the reader has already replied past
 * the cursor: sending a message means they engaged with what was unread, so
 * the line clears (as in Slack and Discord).
 */
export function firstUnreadMessageId(
  messages: CommsMessage[],
  currentUserId: string,
  unreadSinceAt: string | undefined,
): string | undefined {
  if (!unreadSinceAt || repliedPastCursor(messages, currentUserId, unreadSinceAt)) return undefined;
  return messages.find((m) => m.authorId !== currentUserId && m.createdAt > unreadSinceAt)?.id;
}

/** Whether the reader has sent something since the cursor — what clears the line and the "unread above" pill. */
export function repliedPastCursor(messages: CommsMessage[], currentUserId: string, unreadSinceAt: string | undefined): boolean {
  return !!unreadSinceAt && messages.some((m) => m.authorId === currentUserId && m.createdAt > unreadSinceAt);
}
